import { Stack, Typography } from "@mui/material";

type errorQrProps = {
  error: string;
  descripcion: string;
};

export default function ErrorQR({ error, descripcion }: errorQrProps) {
  return (
    <Stack
      sx={{
        padding: 4,
        justifyContent: "center",
        alignItems: "center",
        color: "#933",
        minHeight: "50vh",
        gap: 2,
      }}
    >
      <Typography
        align="center"
        maxWidth="25ch"
        fontWeight="bold"
        sx={{ fontSize: "32px" }}
      >
        {error}
      </Typography>
      <Typography
        variant="h6"
        align="center"
        maxWidth="20ch"
        sx={{ textWrap: "pretty" }}
      >
        {descripcion}
      </Typography>
    </Stack>
  );
}
